import type { StoreKey } from '@printdeal/services-sdk';

export const getAlgoliaApiId = (): string => {
  if (typeof process.env.GATSBY_ALGOLIA_APP_ID !== 'string' || process.env.GATSBY_ALGOLIA_APP_ID === '') {
    throw new Error('The env variable GATSBY_ALGOLIA_APP_ID could not be found.');
  }
  return process.env.GATSBY_ALGOLIA_APP_ID;
};

export const getAlgoliaReadApiKey = (): string => {
  if (typeof process.env.GATSBY_ALGOLIA_READ_API_KEY !== 'string' || process.env.GATSBY_ALGOLIA_READ_API_KEY === '') {
    throw new Error('The env variable GATSBY_ALGOLIA_READ_API_KEY could not be found.');
  }
  return process.env.GATSBY_ALGOLIA_READ_API_KEY;
};

export const getStore = (): StoreKey => {
  if (typeof process.env.GATSBY_STORE !== 'string' || process.env.GATSBY_STORE === '') {
    throw new Error('The env variable GATSBY_STORE could not be found.');
  }
  return process.env.GATSBY_STORE as StoreKey;
};

export const Environment = process.env.GATSBY_ACTIVE_ENV === 'production' ? 'prod' : 'staging';

export const storeEquals = (site: string): boolean => getStore() === site;
export const isSiteNl = () => storeEquals('drukwerkdeal-nl');
export const isSiteBe = () => storeEquals('printdeal-be');

const STORE_LABELS: Record<string, string> = {
  'drukwerkdeal-nl': 'Drukwerkdeal',
  'printdeal-be': 'Printdeal',
  'impressto-fr': 'Impressto',
  drukwerkdeal: 'Drukwerkdeal',
  printdeal: 'Printdeal',
  impressto: 'Impressto',
};

export const getStoreDisplayName = (storeKey?: string): string => {
  if (!storeKey) {
    return '';
  }

  return STORE_LABELS[storeKey] ?? storeKey;
};

export const isOtherStore = (existsInStore?: string): boolean => {
  if (!existsInStore) {
    return false;
  }

  const currentStore = getStore();

  if (existsInStore === currentStore) {
    return false;
  }

  const currentStorePrefix = currentStore.split('-')[0];

  return existsInStore !== currentStorePrefix;
};

const isStaging = () => process.env.GATSBY_ACTIVE_ENV === 'staging';

export const getPPAGAlgoliaSettings = (hitsPerPage?: number) => {
  const indexPrefix = isStaging() ? 'dev_' : 'prod_';
  const siteSuffix = isSiteNl() ? 'drukwerkdeal_products' : 'printdeal_products';

  return {
    indexName: `${indexPrefix}${siteSuffix}`,
    hitsPerPage: hitsPerPage || 12,
  };
};
